import {get} from './base.service'
import {post} from './base.service'
export default{
    /* 取消预约 */
    unLock(params){
        this.addDateParams(params);
        return post('/app/register/unlock',params);
    },
    /* 退号 */
    refund(params){
        this.addDateParams(params);
        return post('/app/register/refund',params);
    },
    /* 获取挂号订单详情 */
    loadRegDetail(params){
        this.addDateParams(params);
        return get('/app/register/detail/{cardType}/{cardNo}/{startDate}/{endDate}/{orderId}',{params:params});
    },
    addDateParams: function(params){
        const today = new  Date();
        params.endDate = params.endDate || today.format('yyyy-MM-dd');
        today.setDate(today.getDate() - 6);
        params.startDate = params.startDate || today.format('yyyy-MM-dd');
    }
}


// WEBPACK FOOTER //
// ./src/service/myRegister.service.js